export default import.meta.ROLLUP_FILE_URL_$F3b35Ap5Zm7Dd_OhpKRhg